var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_2417",
    width: 12.017,
    height: 11.994,
    viewBox: "0 0 12.017 11.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7829",
    d: "M1998.017 857.526v2.66a.6.6 0 0 1-.019.147.57.57 0 0 1-.556.458h-10.87a.569.569 0 0 1-.564-.507.441.441 0 0 1-.008-.1v-2.66a.568.568 0 0 1 1.135 0v2.13h9.75v-2.13a.567.567 0 0 1 .968-.4.6.6 0 0 1 .164.402z",
    className: "cls-1",
    transform: "translate(-1986 -848.798)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7830",
    d: "M1997.4 848.086l-2.788 2.788c0 .008-.012.011-.015.015a.659.659 0 0 1-.367.185h-.034a.408.408 0 0 1-.068 0h-.098a.647.647 0 0 1-.367-.185l-.015-.015-2.788-2.788a.664.664 0 0 1 .939-.938l1.676 1.676v-6.141a.665.665 0 0 1 .662-.662.677.677 0 0 1 .469.193.656.656 0 0 1 .193.469v6.141l1.676-1.676a.667.667 0 0 1 .938 0 .678.678 0 0 1-.013.938z",
    className: "cls-1",
    transform: "translate(-1988.116 -842.021)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.6c8918f0.svg";
export { ForwardRef as ReactComponent };